export default "__VITE_ASSET__S641qK31__"